import { compose } from 'redux';
import { connect } from 'react-redux';
import ExposeLifecycle from 'rlink-expose-lifecycle';
import lookup from 'rlink-data-connector/lookup';
import { allJobPostings } from 'rlink-greenhouse/GreenhouseJob';
import requestData from 'rlink-data-connector/requestData';
import CareersPanel from '../CareersPanel';

function mapStateToProps ({caches}) {
  return {
    jobPostings: lookup(caches, allJobPostings),
  };
}

function mapDispatchToProps (dispatch) {
  return {
    onPropsChange () {
      dispatch(requestData(allJobPostings));
    },
  };
}

let connected = compose(
  connect(mapStateToProps, mapDispatchToProps),
  ExposeLifecycle
)(CareersPanel);

export default connected;



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/connected/CareersPanel.jsx